/**
 * Created by jayed.talukder on 6/26/2019.
 */
export class CollaborationHelper {
  public static convertMessageToDynamicChatParameter(richMessage) {
    let reg = /\[.*?\]/g;
    const regexItems = richMessage.message.match(reg);
    const richItems =[];
    let i =0;
    regexItems.forEach(item => {
      const key = item.replace('[','').replace(']','');
      if(item.indexOf('[anchor') > -1 || item.indexOf('[button') > -1) {
        const metadataItem = richMessage.metadata[key];
        if(metadataItem) {
          richItems.push({
            text: metadataItem.text,
            type: metadataItem.type,
            parameter: metadataItem.parameter
          });
        }
      } else {
        richItems.push({
          text: i > 0? '' + key + '' : key + '',
          type: 'span'
        });
      }
      i++;
    });
    return richItems;
  }

  public static recursiveDeepCopy(o) {
    let newO,
      i;

    if (typeof o !== 'object') {
      return o;
    }
    if (!o) {
      return o;
    }

    if ('[object Array]' === Object.prototype.toString.apply(o)) {
      newO = [];
      for (i = 0; i < o.length; i += 1) {
        newO[i] = this.recursiveDeepCopy(o[i]);
      }
      return newO;
    }

    newO = {};
    for (i in o) {
      if (o.hasOwnProperty(i)) {
        newO[i] =  this.recursiveDeepCopy(o[i]);
      }
    }
    return newO;
  }
}
